export const SITE = {
  name: 'Nasi Padang Sederhana',
  domain: 'https://nasipadangsederhana.com',
  tagline: 'Cita rasa otentik Minangkabau dalam tradisi hidang',
  description:
    'Rumah makan masakan Padang yang menghadirkan hidangan khas Minangkabau: rendang, ayam pop, dendeng balado, gulai, sate Padang, dan sambal ijo.',
};

export const NAV = [
  { to: '/', label: 'Beranda' },
  { to: '/menu/', label: 'Menu' },
  { to: '/tentang/', label: 'Tentang Kami' },
  { to: '/faq/', label: 'FAQ' },
];

export const MENU = [
  {
    category: 'Lauk Daging',
    note: 'Dimasak perlahan hingga bumbu meresap ke serat daging.',
    items: [
      {
        slug: 'rendang-daging',
        name: 'Rendang Daging',
        desc: 'Daging sapi dimasak berjam-jam dalam santan dan rempah hingga kering, pekat, dan beraroma dalam.',
        level: 'Gurih Sedang',
        badge: 'Ikonik',
      },
      {
        slug: 'dendeng-balado',
        name: 'Dendeng Balado',
        desc: 'Irisan daging sapi tipis yang digoreng kering, disiram sambal balado cabai merah segar.',
        level: 'Pedas',
      },
      {
        slug: 'paru-goreng',
        name: 'Paru Goreng',
        desc: 'Paru sapi berbumbu yang digoreng garing dengan taburan serundeng rempah.',
        level: 'Gurih',
      },
      {
        slug: 'gulai-tunjang',
        name: 'Gulai Tunjang',
        desc: 'Kikil sapi yang empuk kenyal dalam kuah gulai kuning kental dan hangat.',
        level: 'Gurih Sedang',
      },
    ],
  },
  {
    category: 'Olahan Ayam',
    note: 'Dari yang lembut gurih hingga berbalut sambal menyala.',
    items: [
      {
        slug: 'ayam-pop',
        name: 'Ayam Pop',
        desc: 'Ayam kampung direbus berbumbu hingga sangat empuk, lalu digoreng sekejap — gurih lembut dengan sambal tomat khas.',
        level: 'Gurih Lembut',
        badge: 'Favorit',
      },
      {
        slug: 'ayam-gulai',
        name: 'Ayam Gulai',
        desc: 'Ayam dalam kuah gulai santan kuning beraroma kunyit, serai, dan daun jeruk.',
        level: 'Gurih Sedang',
      },
      {
        slug: 'ayam-bakar-bumbu',
        name: 'Ayam Bakar Bumbu',
        desc: 'Ayam bakar dengan lumuran bumbu rendang yang meresap hingga ke tulang.',
        level: 'Pedas Sedang',
      },
      {
        slug: 'ayam-balado',
        name: 'Ayam Balado',
        desc: 'Ayam goreng berbalut sambal balado dari cabai merah yang diulek kasar.',
        level: 'Pedas',
      },
    ],
  },
  {
    category: 'Gulai & Kuah',
    note: 'Kuah santan kaya rempah, pendamping setia nasi hangat.',
    items: [
      {
        slug: 'gulai-kepala-kakap',
        name: 'Gulai Kepala Kakap',
        desc: 'Kepala ikan kakap dalam gulai kuning pekat — primadona di meja hidang.',
        level: 'Gurih Sedang',
        badge: 'Istimewa',
      },
      {
        slug: 'gulai-nangka',
        name: 'Gulai Nangka',
        desc: 'Nangka muda dimasak santan bersama cabai, daun kunyit, dan lengkuas.',
        level: 'Gurih Lembut',
      },
      {
        slug: 'sayur-daun-singkong',
        name: 'Sayur Daun Singkong',
        desc: 'Daun singkong rebus yang lembut, pendamping wajib sepiring nasi Padang.',
        level: 'Gurih Lembut',
      },
      {
        slug: 'soto-padang',
        name: 'Soto Padang',
        desc: 'Kaldu bening gurih dengan dendeng iris, perkedel, dan kerupuk merah muda.',
        level: 'Gurih Hangat',
      },
    ],
  },
  {
    category: 'Sate & Pendamping',
    note: 'Pelengkap meja yang membuat hidangan semakin ramai.',
    items: [
      {
        slug: 'sate-padang',
        name: 'Sate Padang',
        desc: 'Potongan daging dan lidah berbalut kuah kacang-kunyit yang kental dan hangat.',
        level: 'Pedas Sedang',
      },
      {
        slug: 'telur-dadar-padang',
        name: 'Telur Dadar Padang',
        desc: 'Telur dadar tebal khas Padang yang gurih, berserat, dan mengembang.',
        level: 'Gurih',
      },
      {
        slug: 'telur-balado',
        name: 'Telur Balado',
        desc: 'Telur rebus goreng berbalut sambal balado merah yang meresap.',
        level: 'Pedas',
      },
      {
        slug: 'kerupuk-kulit',
        name: 'Kerupuk Kulit',
        desc: 'Kerupuk jangek renyah, paling nikmat dicelup ke kuah gulai.',
        level: 'Gurih',
      },
    ],
  },
  {
    category: 'Sambal & Pelengkap',
    note: 'Nyawa rasa di setiap meja makan.',
    items: [
      {
        slug: 'sambal-ijo',
        name: 'Sambal Ijo',
        desc: 'Cabai hijau keriting diulek dengan tomat hijau dan bawang — segar dan menggigit.',
        level: 'Pedas',
        badge: 'Wajib Coba',
      },
      {
        slug: 'sambal-balado-merah',
        name: 'Sambal Balado Merah',
        desc: 'Cabai merah keriting ditumis hingga berminyak dan harum.',
        level: 'Pedas',
      },
      {
        slug: 'lalapan-kobokan',
        name: 'Lalapan & Kobokan',
        desc: 'Sayur segar serta kobokan air jeruk untuk membersihkan tangan dan langit-langit.',
        level: 'Segar',
      },
    ],
  },
];

export const SIGNATURES = [
  { slug: 'rendang-daging', name: 'Rendang Daging', desc: 'Kering, pekat, beraroma rempah dalam.', img: '/images/rendang.jpg', alt: 'Sepiring rendang daging sapi berbumbu pekat khas Padang' },
  { slug: 'ayam-pop', name: 'Ayam Pop', desc: 'Empuk, gurih lembut, sambal tomat khas.', img: '/images/ayam.jpg', alt: 'Sepiring nasi Padang dengan lauk gulai dan sayuran segar' },
  { slug: 'sate-padang', name: 'Sate Padang', desc: 'Kuah kacang-kunyit kental yang hangat.', img: '/images/sate.jpg', alt: 'Tusuk sate dibakar di atas arang yang membara' },
  { slug: 'gulai-kepala-kakap', name: 'Gulai Kepala Kakap', desc: 'Kuah kuning pekat, primadona meja hidang.', img: '/images/gulai.jpg', alt: 'Semangkuk gulai berkuah kuning kental kaya rempah' },
];

export const SPICES = [
  { name: 'Kunyit', desc: 'Memberi warna kuning keemasan pada gulai.', icon: 'sun' },
  { name: 'Serai', desc: 'Aroma segar yang mengangkat kuah santan.', icon: 'leaf' },
  { name: 'Lengkuas', desc: 'Rasa hangat khas di setiap bumbu dasar.', icon: 'sprout' },
  { name: 'Cabai Keriting', desc: 'Jantung sambal balado dan sambal ijo.', icon: 'flame' },
  { name: 'Santan Kelapa', desc: 'Kelembutan gurih dari kelapa segar.', icon: 'milk' },
  { name: 'Buah Pala', desc: 'Sentuhan hangat dalam rendang pekat.', icon: 'nut' },
];

export const FAQS = [
  {
    q: 'Apa itu nasi Padang?',
    a: 'Nasi Padang adalah hidangan nasi hangat yang disajikan bersama aneka lauk khas Minangkabau, Sumatera Barat — seperti rendang, gulai, dendeng, dan sayur daun singkong — lengkap dengan sambal. Hidangan ini dikenal karena bumbunya yang kaya dan penggunaan santan yang melimpah.',
  },
  {
    q: 'Apa yang dimaksud dengan penyajian "hidang"?',
    a: 'Dalam tradisi rumah makan Padang, pelayan menghidangkan banyak piring kecil berisi beragam lauk sekaligus ke meja Anda. Anda tinggal memilih yang ingin disantap — piring yang tidak disentuh tidak dihitung. Cara makan ini disebut hidang atau saji hidang.',
  },
  {
    q: 'Apakah semua masakan Padang pedas?',
    a: 'Tidak. Banyak hidangan Padang justru gurih lembut, misalnya ayam pop, gulai nangka, dan sayur daun singkong. Rasa pedas umumnya datang dari sambal yang disajikan terpisah, sehingga Anda bisa mengatur sendiri tingkat kepedasannya.',
  },
  {
    q: 'Apa perbedaan rendang dan gulai?',
    a: 'Rendang dimasak perlahan hingga kuah santannya mengering dan bumbunya meresap pekat ke dalam daging, sedangkan gulai disajikan berkuah santan kuning yang kaya rempah. Keduanya berasal dari tradisi memasak Minangkabau.',
  },
  {
    q: 'Apa itu ayam pop?',
    a: 'Ayam pop adalah hidangan khas Minangkabau berupa ayam kampung yang direbus bersama bumbu hingga sangat empuk, lalu digoreng sebentar sehingga warnanya tetap pucat khas. Rasanya gurih lembut dan biasanya disantap dengan sambal tomat.',
  },
  {
    q: 'Bagaimana cara menghitung harga saat makan secara hidang?',
    a: 'Harga dihitung dari piring lauk yang benar-benar Anda santap. Jika ragu, jangan sungkan bertanya dahulu kepada pelayan sebelum mengambil lauk — itu hal yang wajar di rumah makan Padang.',
  },
  {
    q: 'Apa pendamping yang paling cocok untuk rendang?',
    a: 'Paduan klasiknya adalah nasi hangat, sayur daun singkong rebus, dan sambal ijo. Kuah gulai nangka di atas nasi juga membuat rasa rendang semakin seimbang.',
  },
];

const breadcrumb = (name, path) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Beranda', item: `${SITE.domain}/` },
    { '@type': 'ListItem', position: 2, name, item: `${SITE.domain}${path}` },
  ],
});

export const ROUTES = [
  {
    path: '/',
    title: 'Nasi Padang Sederhana — Rumah Makan Masakan Padang & Minangkabau',
    description:
      'Nasi Padang Sederhana menghadirkan hidangan khas Minangkabau: rendang, ayam pop, dendeng balado, gulai, sate Padang, dan sambal ijo. Jelajahi daftar hidangan dan kenali tradisi hidang khas rumah makan Padang.',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Restaurant',
        name: SITE.name,
        url: `${SITE.domain}/`,
        image: `${SITE.domain}/images/og.jpg`,
        description: SITE.description,
        servesCuisine: ['Masakan Padang', 'Masakan Minangkabau', 'Masakan Indonesia'],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: SITE.name,
        url: `${SITE.domain}/`,
        inLanguage: 'id',
      },
    ],
  },
  {
    path: '/menu/',
    title: 'Daftar Hidangan Masakan Padang | Nasi Padang Sederhana',
    description:
      'Jelajahi daftar hidangan khas Minangkabau: rendang daging, ayam pop, dendeng balado, gulai kepala kakap, sate Padang, sambal ijo, dan berbagai pelengkap meja hidang lainnya.',
    jsonLd: breadcrumb('Menu', '/menu/'),
  },
  {
    path: '/tentang/',
    title: 'Tentang Kami & Tradisi Hidang | Nasi Padang Sederhana',
    description:
      'Mengenal Nasi Padang Sederhana dan budaya hidang khas rumah makan Padang: puluhan piring kecil dihidangkan sekaligus, Anda hanya membayar yang disantap.',
    jsonLd: breadcrumb('Tentang Kami', '/tentang/'),
  },
  {
    path: '/faq/',
    title: 'Pertanyaan Umum Seputar Masakan Padang | Nasi Padang Sederhana',
    description:
      'Jawaban atas pertanyaan yang sering diajukan seputar nasi Padang: tradisi hidang, tingkat kepedasan, perbedaan rendang dan gulai, hingga cara menghitung harga.',
    jsonLd: [
      breadcrumb('FAQ', '/faq/'),
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQS.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      },
    ],
  },
];

export const NOT_FOUND_META = {
  path: '/404',
  title: 'Halaman Tidak Ditemukan | Nasi Padang Sederhana',
  description: 'Halaman yang Anda cari tidak tersedia. Kembali ke beranda Nasi Padang Sederhana.',
};

export function getRouteMeta(path) {
  const p = path !== '/' && !path.endsWith('/') ? path + '/' : path;
  return ROUTES.find((r) => r.path === p) || NOT_FOUND_META;
}
